import { HStack, colors, VStack, Checkbox } from "goi_common";
import { PropsWithChildren } from "react";

const Base = ({ children }: PropsWithChildren<object>) => {
  return (
    <HStack
      gap="24px"
      padding="16px 24px"
      css={{
        background: colors.white,
        borderTop: `1px solid ${colors.gray100}`,
        borderBottom: `1px solid ${colors.gray100}`,
        width: "100%",
        minHeight: "76px",
      }}
      alignItems="center"
    >
      {children}
    </HStack>
  );
};

// 관계 컴포넌트
const Relation = ({ children }: PropsWithChildren<object>) => (
  <div
    className="body2 brown350"
    css={{
      minWidth: "65px",
    }}
  >
    {children}
  </div>
);

// 이름 컴포넌트
const Name = ({ children }: PropsWithChildren<object>) => (
  <div
    className="subtitle1_sb balck"
    css={{
      width: "100%",
    }}
  >
    {children}
  </div>
);

// 체크버튼 컴포넌트
const Radio = ({
  index,
  isChecked,
  checkedColor = colors.danger,
  onChange,
}: {
  index: number;
  isChecked: boolean;
  checkedColor: string;
  onChange: () => void;
}) => {
  return (
    <HStack
      className="aa"
      css={{
        minWidth: "96px",
        justifyContent: "flex-end",
      }}
    >
      <Checkbox
        index={index}
        checked={isChecked}
        checkedColor={checkedColor}
        borderType="circle"
        onChange={onChange}
      />
    </HStack>
  );
};

const ShareButton = ({
  disabled,
  onClick,
  children,
}: PropsWithChildren<{
  disabled: boolean;
  onClick: () => void;
}>) => {
  return (
    <VStack
      as="button"
      className="body_14_sb white"
      disabled={disabled}
      css={{
        borderRadius: "5px",
        padding: "8px 12px",
        background: colors.black,
        whiteSpace: "nowrap",
        [":disabled"]: {
          opacity: 0.2,
        },
      }}
      onClick={onClick}
    >
      {children}
    </VStack>
  );
};

const SecondaryButton = ({
  onClick,
  children,
}: PropsWithChildren<{
  onClick: () => void;
}>) => {
  return (
    <VStack
      as="button"
      className="body_14_sb"
      css={{
        borderRadius: "5px",
        padding: "8px 12px",
        background: "transparent",
        border: `1px solid ${colors.gray300}`,
        color: colors.gray700,
        whiteSpace: "nowrap",
      }}
      onClick={onClick}
    >
      {children}
    </VStack>
  );
};

export const BugoShareSangjuItem = {
  Base,
  Name,
  Relation,
  Radio,
  ShareButton,
  SecondaryButton,
};
